import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DoctorService } from '../../services/doctor.service';
import { MatSnackBar, MatDialog , MatDialogRef} from '@angular/material';
import { DocumentviewerComponent } from '../../doctor/documentviewer/documentviewer.component';
@Component({
  selector: 'app-patientprofile',
  templateUrl: './patientprofile.component.html',
  styleUrls: ['./patientprofile.component.css']
})
export class PatientprofileComponent implements OnInit {
  loading: any;
  patient_id: any;
  userdata: any;
  userpet: any;
  document = [];
  p = 1;
  nopet = 0;
  constructor(private route: ActivatedRoute, private router: Router ,
    private doctorService: DoctorService, private dialog: MatDialog) {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.patient_id = id;
    });
   }

  ngOnInit() {
      this.doctorService.getUserPetInfo(this.patient_id)
      .subscribe(
        (x) => {
          this.userpet = x;
          if (this.userpet && this.userpet.length > 0) {
            for (let i = 0; i < this.userpet.length ; i++) {
              this.getPetDocument(this.userpet[i].id);
            }
          }else {
            this.nopet = 1;
          }
        });
  }
  getPetDocument(pid) {
    this.doctorService.getUploadDocument(pid)
    .subscribe(
      (x) => {
        if (x.length > 0) {
          for (let i = 0; i < x.length ; i++) {
            this.document.push(x[i]);
          }
        }
      });
  }
  viewDocument(pid) {
      const dialogRef = this.dialog.open(DocumentviewerComponent, {
        width: '400px',
        height: '450px',
        data: {pid: pid},
      });
  }
  documentCount(pid) {
    let count = 0;
    for ( let i = 0; i < this.document.length; i++) {
      if (this.document[i].pet_id == pid) {
        count = count + 1;
       }
    }
    return count;
  }
}
